export default {
  registration: {
    header: {
      title: '專用使用者登錄頁面',
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: '這裡是受託利用本服務的企業專用使用者登錄頁面。',
      section_two: '請輸入連結密碼後繼續進行。',
      section_three: '若不清楚數字密碼時，請洽詢委託 貴公司提供本服務的企業。',
      passcode: '瀏覽用密碼',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: '輸入內容不齊全。',
      unexpected_error: '發生意外錯誤。',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: '請輸入承辦人的電子信箱。',
      email: '電子郵件地址',
      email_placeholder: '請輸入電子郵件地址',
    },
    sent: {
      section_one: '我們已發送郵件至您輸入的電子信箱。',
      section_two: '請請確認郵件後，點擊郵件內的連結註冊帳號。',
      section_three: '若30分鐘後仍未收到郵件，請通知',
      section_four: '',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: '您輸入的電子信箱已經註冊過ASUENE/ASUENE ESG的帳號。',
      section_two: '請輸入您註冊的密碼。',
      password: '密碼',
      // password_placeholder: '',
      error_auth: '驗證失敗。請重新嘗試。',
      // error_linking: '',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: '請輸入　貴公司的公司資訊和負責人姓名等。',
      section_three: '申請後用已完成登錄的帳號登入，即可回答新調查表／問卷調查。',
      buyer_name: '原委託評估企業名稱',
      expires_date: '登錄頁面的有效期限',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: '公司名稱',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: '※已顯示您輸入的電子信箱',
      phone: '電話號碼',
      phone_placeholder: '0000000000',
      locale: '選擇語言',
      section_one: '請同意',
      rule: '使用規約',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' 和 ',
      policy: '個人資料保護方針',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: '後繼續進行。',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: '感謝您的申請。',
      section_two: '已寄送登入ID和密碼至所輸入的電子郵件地址。',
      section_three: '請於確認後，依循郵件內容登入。',
      section_four: '若30分鐘後仍未收到郵件，請通知',
      section_five: '',
      section_six: '將由專責人員另行與您聯絡。',
    },
    expired: {
      section_one: '指定的URL已過有效期限。',
      section_two: '欲使用時，請發送郵件至',
      section_three: '通知我們。將由專責人員另行與您聯絡。',
    },
    error: {
      section_one: '未發現指定的URL。',
      section_two: '煩請重新確認URL。',
    },
    btn: {
      submit: '寄送',
      service_top: '服務首頁',
      login: '登入',
      register: '登錄',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
